import React, { useEffect, useState } from 'react'
import MEIIndividualsImports from 'src/pages/ReportsPages/ReportsBoard/MEIpages/MEIIndividualsImports'
import boardReportsService from 'src/services/boardReportsService'

const MEIIndividualContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [table1, setTable1] = useState([])
  const [gMei1, setGMei1] = useState([])

  const handleDateChange = (value) => {
    setSelectedDate(value)
  }

  const reloadImports = async () => {
    const [table, gMei] = await Promise.all([
      boardReportsService.getTotalMEI(1, selectedDate.getFullYear()),
      boardReportsService.graphicsTotalMEI(1, selectedDate.getFullYear()),
    ])
    setTable1(table)
    setGMei1(gMei)
  }

  useEffect(() => {
    reloadImports()
  }, [])

  return (
    <MEIIndividualsImports
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      table1={table1}
      gMei1={gMei1}
    />
  )
}

export default MEIIndividualContainer
